<template>

<div class="content-select" :class="{'is-active': active}" v-bind:style="{'marginLeft': window.menuIndentContent}">

	<div class="inner">

		<div class="content-select-count">
			{{ active }} <plural :n="active" :t="noun" /> selected
		</div>

		<div class="content-select-actions">

			<core-content-select-type :active="active" text="Selection" icon="check-square">

				<core-content-select-action text="Select all" name="selection/all" />
				<core-content-select-action text="Deselect all" name="selection/none" />
				<core-content-select-action text="Invert" name="selection/invert" />

			</core-content-select-type>

			<core-content-select-type :active="active" text="Tags" icon="tags" v-if="can.tag">

				<com-tags v-on:add="onTagAdd" :tagging="is.tagging" v-on:remove="onTagRemove" />

				<core-dropdown-item type="divide" />

				<core-content-select-action text="Create new tag" name="tags/create" :loading="true" />

				<core-content-select-divide />

				<core-content-select-action text="Clear all" name="tags/clear" :loading="true" />

			</core-content-select-type>

			<core-content-select-type :active="active" text="Filter" icon="filter" v-if="can.filter">

				<core-content-select-action text="Only show these games" name="filter/subset" :loading="true" v-if="filterSubsetApplicable" />
				<core-content-select-action text="Always include games" name="filter/include/add" :loading="true" v-if="filterIncludeAddApplicable" />
				<core-content-select-action text="Don't always include games" name="filter/include/remove" :loading="true" v-if="filterIncludeRemoveApplicable" />
				<core-content-select-action text="Always exclude games" name="filter/exclude" :loading="true" />

			</core-content-select-type>

			<core-content-select-type :active="active" text="List" icon="list" v-if="can.list.remove">

				<core-content-select-action text="Remove" name="list/remove" :loading="true" />

			</core-content-select-type>

			<core-content-select-type :active="active" text="Users" icon="users" v-if="can.users.remove">

				<core-content-select-action text="Remove" name="users/remove" :loading="true" />

			</core-content-select-type>

			<core-content-select-type :active="active" text="Export" icon="file-download" v-if="can.export">

				<core-content-select-action text="As CSV" name="export/csv" :loading="true" />
				<core-content-select-action text="To Clipboard" name="export/clipboard" :loading="true" />

			</core-content-select-type>

		</div>

	</div>

</div>

</template>

<script>

import comTags from './modal/Tags'

export default {

	props: ['noun'],

	components: {
		comTags
	},

	data: function() {

		return {
			is: {
				tagging: false
			}

		}

	},

	computed: {

		contextTitle: function() {

			return this.$CONSTANTS.SERVICE.TITLE[this.$store.getters['service/select/name']] + ' tags'

		},

		gameTags: function() {

			return this.$_.where(this.$store.getters['data/tags/list'], {
				context: 0
			})

		},

		contextTags: function() {

			return this.$_.where(this.$store.getters['data/tags/list'], {
				context: this.$CONSTANTS.SERVICE.VALUE[this.$store.getters['service/select/name']]
			})

		},

		can: function() {

			return this.$store.getters['service/select/can']

		},

		active: function() {

			return this.$store.getters['service/select/count']

		},

		filterSubsetApplicable: function() {

			return true

		},

		filterIncludeAddApplicable: function() {

			return true

		},

		filterIncludeRemoveApplicable: function() {

			return true

		}

	},

	methods: {

		onTagAdd: function(tag) {

			this.is.tagging = tag.id

			this.$store.dispatch('service/select/tags/add', {
				tag: tag
			}).then(function() {

				this.is.tagging = false

			}.bind(this))

		},

		onTagRemove: function(tag) {

			this.is.tagging = tag.id

			this.$store.dispatch('service/select/tags/remove', {
				tag: tag
			}).then(function() {

				this.is.tagging = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.content-select {
	position: fixed;
	bottom: -50px;
	height: 40px;
	left: 4px;
	overflow: hidden;
	right: 4px;
	border-radius: 4px;
	width: calc(100% - 8px);
	background-color: #fff;
	transition: bottom 300ms ease-in-out, margin-left 100ms linear;
	z-index: 2;
	box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}

.content-select >>> .dropdown-item-tag-color {
	left: 10px;
}

.content-select >>> .button {
	border-radius: 0px;
	margin-left: 0px!important;
}

.content-select.is-active {
	bottom: 4px;
}

.content-select .inner {
	display: flex;
	justify-content: space-between;
	padding: 0px 7px;
}

.is-mobile .content-select .inner {
	padding-right: 0px;
}

.content-select-count {
	font-size: 16px;
	font-weight: 400;
	line-height: 40px;
	flex-shrink: 1;
	color: #343434;
}

.is-mobile .content-select-count {
	font-size: 12px;
}

.content-select-actions {
	display: flex;
	flex-grow: 1;
	justify-content: flex-end;
}

.content-select-actions >>> .action .button {
    border-radius: 0px!important;
    border-left: 1px solid #eee!important;
}


.content-select-actions >>> .action .button-badge {
    right: 0px;
	top: 0px;
	background-color: transparent;
	color: #343434;
	border-radius: 0px;
}

</style>
